// 这里面处理鉴权的逻辑
import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({ showSpinner: false }) // NProgress Configuration

// 判断是否有token,没有则登陆
router.beforeEach((to, from, next) => {
  // start progress bar
  NProgress.start()
  if (to.path !== '/login' && to.path !== '/401' && to.path !== '/404') {
    var token = sessionStorage.getItem('token')
    if (token === null) {
      NProgress.done()
      // next({ path: '/login' })
      next()
    } else {
      NProgress.done()
      next()
    }
  } else {
    NProgress.done()
    next()
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
